<template>
  <div class="programmirovanie-study">
    <div class="v2-container-small programmirovanie-study__head">
      <h2 class="title-secondary">
        как проходит обучение
      </h2>

      <div class="no-mobile">
        <button
          class="m-btn"
          @click="prevSlide"
        >
          <img
            loading="lazy"
            src="/v2/catalog/programmirovanie/slider-button.svg"
            alt="prev"
          >
        </button>
        <button
          class="m-btn rotate-180"
          @click="nextSlide"
        >
          <img
            loading="lazy"
            src="/v2/catalog/programmirovanie/slider-button.svg"
            alt="next"
          >
        </button>
      </div>
    </div>

    <custom-scroll-slider
      ref="slider"
      :items="slides"
      :container-width="1240"
      :gap="20"
    >
      <template #item="{ slide: study, index }">
        <div class="programmirovanie-study__slide">
          <span
            :style="{ color: study.color }"
            v-html="study.title"
          />
          <p v-html="study.text" />

          <img
            :src="`/v2/catalog/programmirovanie/study/${index + 1}.svg`"
            :alt="index + 1"
          >
        </div>
      </template>
    </custom-scroll-slider>
  </div>
</template>

<script>
import CustomScrollSlider from '../../common/CustomScrollSlider.vue';

export default {
  name: 'ProgrammirovanieStudy',
  components: { CustomScrollSlider },
  data: () => ({
    slides: [
      {
        image: '1',
        title: 'Вебинары <br> и видеоуроки',
        color: '#FB5018',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'Вебинары, где&nbsp;преподаватель вживую общается с&nbsp;группой учеников, посещаете дважды в&nbsp;неделю, а&nbsp;видеоуроки курсов смотрите в&nbsp;любое удобное время <br> на&nbsp;специальной образовательной платформе',
      },
      {
        image: '2',
        title: 'Практические задания',
        color: '#4A88DA',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'С&nbsp;первых&nbsp;же&nbsp;уроков даются задания для&nbsp;самостоятельного выполнения от&nbsp;преподавателя по&nbsp;пройденной теме, чтобы&nbsp;можно было сразу закрепить полученные знания на&nbsp;практике',
      },
      {
        image: '3',
        title: 'Обратная связь&nbsp;и&nbsp;поддержка',
        color: '#22AE73',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'Наши преподаватели проверяют домашние задания, а&nbsp;кураторы решают технические вопросы. В&nbsp;специальном чате можно пообщаться с&nbsp;другими учениками и&nbsp;задать вопросы',
      },
      {
        image: '4',
        title: 'Выпускной документ',
        color: '#846EFB',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'После&nbsp;завершения учебной программы каждому ученику школы выдается именной сертификат об&nbsp;успешном прохождении обучения на&nbsp;курсе',
      },
    ],
  }),
  methods: {
    nextSlide() {
      this.$refs.slider.nextSlide();
    },
    prevSlide() {
      this.$refs.slider.prevSlide();
    },
  },
};
</script>

<style scoped lang="scss">

.programmirovanie-study {
  &__head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 60px;

    @include media-down(mobile) {
      margin-bottom: 32px;
    }

    h2 {
      letter-spacing: -0.03em;

      @include media-down(mobile) {
        max-width: 328px;
        font-size: 26px;
        letter-spacing: -0.02em;
      }
    }

    div {
      display: flex;
      gap: 12px;
    }

    button {
      line-height: 0;
    }
  }

  .custom-slider {
    padding-bottom: 20px;
    margin-bottom: -20px;

    @include media-down(mobile) {
      flex-direction: column;
    }
  }

  &__slide {
    width: 435px;
    min-height: 400px;
    padding: 30px;

    position: relative;
    background-image: url("/v2/catalog/programmirovanie/reviews/bg.svg");
    background-size: 100% 100%;
    filter: drop-shadow(4px 4px 20px rgba(7, 21, 57, 0.05));

    @include media-down(mobile) {
      padding: 20px 8px;
      max-width: 344px;
      width: 100%;

      background-image: url("/v2/catalog/programmirovanie/study/bg-mob.svg");
      border-radius: 20px;
      overflow: hidden;
    }

    img {
      position: absolute;
      width: 224px;
      right: 30px;
      bottom: 0;

      @include media-down(mobile) {
        right: 8px;
      }
    }

    p {
      margin-top: 20px;

      font-weight: 500;
      font-size: 18px;
      line-height: 130%;
      letter-spacing: -0.01em;
      font-feature-settings: 'pnum' on, 'lnum' on;
      color: rgba($black, 0.5);
    }

    span {
      font-weight: 700;
      font-size: 30px;
      line-height: 90%;
      letter-spacing: -0.02em;

      @include media-down(mobile) {
        font-size: 26px;
      }
    }
  }
}

</style>
